import React from 'react';
import { IconButton } from '@material-ui/core';
import { ExportIcon } from '../../../../styles';
import { 
    CustomerSelect, 
    FlexBox, 
    Header, 
    Title, 
} from './styles';

function MachineDistributionHeader({
    title = '',
    viewBy = [],
    selectOptions = [],
    onChangeViewBy,
    onExport,
}) {
    return (
        <Header>
            <Title text={title} />
            <FlexBox>
                <CustomerSelect
                    onChange={onChangeViewBy}
                    defaultValue={viewBy}
                    items={selectOptions} />
                <IconButton onClick={onExport} size='small'>
                    <ExportIcon />
                </IconButton>
            </FlexBox>
        </Header>
    );
};

export default MachineDistributionHeader;